<template>
	<div class="document-link-list grid-md gutters-150-md display-flex-md flex-wrap-wrap-md">
		<LiteratureLinkItem
			v-for="literature in props.literatureList"
			:key="literature.title"
			class="col-6-md display-block mt-100"
			:literature="literature"
		/>
	</div>
</template>

<script setup lang="ts">
import { FundLiterature } from 'types/funds';
import LiteratureLinkItem from '@components/offering-details/literature-link-item.vue';

interface Props {
	literatureList: Array<FundLiterature>;
}

const props = defineProps<Props>();
</script>
